import { ApplicationState } from '../reducers/index'

export const getUser = (state: ApplicationState) => state.applicationUser.user
